import "./src/styles/global.css"

export const onRouteUpdate = ({ location }) => {
  // Track page views on every route change
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("config", "AW-17805299607", {
      page_path: location.pathname + location.search,
    })
  }

  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq("track", "PageView")
  }
}
